import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import CommonToast from "../../../../components/_utils/CommonToast";
import {
  taxCompliantAccountApprove,
  taxCompliantAccountReject,
} from "../../../../redux/features/accounts/taxAccount/taxAccountApproval";
import { taxCompliantAccountDetail } from "../../../../redux/features/accounts/taxAccount/taxAccountDetails";
import { beneBankLookUp } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import { beneLookUp } from "../../../../redux/features/verifyPAN/verifyPAN";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";

const TaxationAccountSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    tax: "",
    pan: "",
    labels: "",
  });

  const services = useSelector((state) => state.refreshToken.services);
  const { taxCompliantDetailsData } = useSelector(
    (state) => state.taxCompliantAccountDetail,
  );
  const beneLookData = useSelector((state) => state.verify);

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const capitalize = (text) =>
    text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
  const accountData = taxCompliantDetailsData?.tds_accounts[0];

  const accountApproval = () => {
    (async () => {
      toast.dismiss();
      CommonToast({
        text: "Tax account getting approved",
        variant: "var(--processing)",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      let response = await dispatch(taxCompliantAccountApprove({ id }));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Tax account approved",
          variant: "var(--success)",
          icon: ICONS.SELECTED_WITH_WHITE_FILLED,
          buttonNeeded: false,
        });

        navigate(
          `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${id}`,
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.tds_accounts[0],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          buttonNeeded: false,
        });
      }
    })();
  };
  const accountRejected = () => {
    (async () => {
      toast.dismiss();
      CommonToast({
        text: "Tax account getting rejected",
        variant: "var(--processing)",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      let response = await dispatch(
        taxCompliantAccountReject({
          id,
          rejectionReason: AccountIdData,
        }),
      );
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Tax account rejected",
          variant: "var(--success)",
          icon: ICONS.SELECTED_WITH_WHITE_FILLED,
          buttonNeeded: false,
        });

        navigate(
          `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${id}`,
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.beneficiary_account[0],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          buttonNeeded: false,
        });
        setRejectPopup(false);
      }
    })();
  };

  const createTxnHandler = () => {
    navigate("/tax_transaction_dashboard/create_tax_transaction", {
      state: currentAccountDetails,
    });
  };

  const createAccountHandler = () => {
    navigate("/tax_account_dashboard/create_tax_account");
  };

  const viewDetailsHandler = () => {
    navigate(
      `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${id}`,
    );
  };

  const dashboardHandler = () => {
    navigate("/tax_account_dashboard");
  };

  const formatTaxType = (value = "") => {
    if (!value) return "Not assigned";

    const key = value.toLowerCase();

    switch (key) {
      case "income_tax":
        return "Income Tax";
      case "tds":
        return "TDS";
      case "gst":
        return "GST";
      case "pt":
        return "PT";
      default:
        return value;
    }
  };

  useEffect(() => {
    dispatch(taxCompliantAccountDetail(id));
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [id, dispatch]);

  useEffect(() => {
    if (!accountData) return;

    dispatch(beneLookUp({ pan_number: accountData.pan_no }));

    dispatch(
      beneBankLookUp({
        ifsc: accountData.ifsc_code,
        bank_account_no: accountData.bank_acc_no,
      }),
    );
  }, [accountData, dispatch]);

  const buttonRows = [
    ...(services?.includes("BAAccount") ||
    (services?.includes("Admin") && accountData?.approval_status === "pending")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_CIRCLE_RED_ICON,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECTED_WITH_WHITE_FILLED,
              handleFunction: () => {
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),

    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.SELECTUSER,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.ADD_BUTTON,
        handleFunction: createTxnHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],

    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];
  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    setDeclineReason(sanitizedValue);
  };
  const AccountIdData = declineReason;

  return (
    <div>
      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            subtext="Please state the reason for rejecting the account"
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            noteText=" The reason must consist of at least 10 characters."
            inputPlaceholder="Reason"
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              handleInputChange(e);
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneHandleFunction={() => {
              setRejectPopup(false);
            }}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="trans"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length <
                GlobalConfiguration?.owneraccountnormalLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              accountRejected();
            }}
            btnTwoBtnType="submit"
          />
        </div>
      )}
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={"Tax account created successfully and awaiting approval."}
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.name,
                  leftSubTitle: "Account name - Suggested name",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: formatTaxType(accountData?.category),
                  leftSubTitle: "Tax types",
                },
              ]}
            />
            {accountData?.type_of_account?.toLowerCase() === "tds" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: accountData?.tax_section?.section_name,
                    leftSubTitle: "Tax section",
                    hasRight: true,
                    rightText: true,
                    rightTitle: capitalize(
                      accountData?.tax_section?.description,
                    ),
                    rightSubTitle: "Section description",
                    rightTitleTextColor: "var(--text-primary)",
                  },
                ]}
              />
            )}
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.pan_no,
                  leftSubTitle: "PAN number",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: standardAccountNumberFormat(
                    accountData?.bank_acc_no,
                    true,
                  ),
                  leftSubTitle: "Account number",
                  ifsc: accountData?.ifsc_code,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.ifsc_code,
                  leftSubTitle: "IFSC code",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.contact_no,
                  leftSubTitle: "Contact number",
                  icon: ICONS.CONTACT_NO,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.email_id,
                  leftSubTitle: "Email ID",
                  icon: ICONS.GMAIL_RED_ERROR,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.gstin_detail
                    ? accountData?.gstin_detail
                    : "Not given",
                  leftSubTitle: "GSTIN (optional)",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array?.isArray(accountData?.labels) &&
                    accountData?.labels?.length >
                      GlobalConfiguration?.lengthCheckZero
                      ? accountData.labels.map((l) => l).join(", ")
                      : "Not assigned",
                  leftSubTitle: "Labels (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.recipient_email
                    ? accountData?.recipient_email
                    : "Not added",
                  leftSubTitle: "Recipients (optional)",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        {beneLookData?.beneLookData?.beneficiary_accounts?.length >
          GlobalConfiguration?.lengthCheckZero && (
          <TabsWeapperSection title="Accounts associated to PAN">
            {beneLookData?.beneLookData?.beneficiary_accounts
              ?.filter(
                (accountData) =>
                  accountData?.approval_status === "pending" ||
                  accountData?.approval_status === "approved",
              )
              .map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  rightHeaderTextSize="var(--font-xs)"
                  rightHeaderTextColor="var(--text-secondary)"
                  leftHeaderText={accountNameStandardised(
                    accountData?.bank_account_holder_full_name,
                  )}
                  leftHeaderWidth="w-width-lg"
                  rows={[
                    {
                      leftTitle: standardAccountNumberFormat(
                        accountData?.bank_acc_no,
                      ),

                      leftSubTitle: "Bank account number",
                      ifsc: accountData?.ifsc_code,
                    },
                  ]}
                />
              ))}
          </TabsWeapperSection>
        )}

        {Array?.isArray(benebankLookData?.beneficiary_accounts) &&
          benebankLookData?.beneficiary_accounts?.length >
            GlobalConfiguration?.lengthCheckZero && (
            <TabsWeapperSection title="Accounts Associated to Bank">
              {benebankLookData?.beneficiary_accounts
                .filter(
                  (accountData) =>
                    accountData?.approval_status === "pending" ||
                    accountData?.approval_status === "approved",
                )
                .map((accountData, id) => (
                  <InfoCard
                    key={id}
                    bgColor="var(--positive-card)"
                    header={true}
                    borderColor="var(--positive-bg)"
                    rightHeaderText={`${
                      accountData?.approval_status?.charAt(0).toUpperCase() +
                      accountData?.approval_status?.slice(1)
                    } account`}
                    rightHeaderTextSize="var(--font-xs)"
                    rightHeaderTextColor="var(--text-secondary)"
                    leftHeaderText={accountNameStandardised(accountData?.name)}
                    leftHeaderWidth="w-width-lg"
                    rows={[
                      {
                        leftTitle: accountData?.pan_no,
                        leftSubTitle: "PAN number",
                      },
                    ]}
                  />
                ))}
            </TabsWeapperSection>
          )}
      </StatusContainer>
    </div>
  );
};

export default TaxationAccountSuccess;
